import React from "react";
import { ArrowRight } from "phosphor-react";
import NewHeader from "../helper/NewHeader";

function LanguageListingPage() {
  return (
    <>
      <NewHeader/>
      <main role="main" className="contentarea">
      <div className="container">
        <div className="listTitle">
          <h2>Select by Subject:</h2>
          <ul className="d-flex justify-content-between list">
            <li>
              <button>LAW</button>
            </li>
            <li>
              <button className="physics">Physics</button>{" "}
            </li>
            <li>
              <button className="chemistry">Chemistry</button>
            </li>
            <li>
              <button className="biology">Biology</button>
            </li>
            <li>
              <ArrowRight size={32} /> see more{" "}
            </li>
          </ul>
        </div>
        <div className="listTitle">
          <h2>Select Language:</h2>
          <ul className="d-flex justify-content-between list">
            <li>
              <button className="eng">English </button>
            </li>
            <li>
              <button className="hind">Hindi</button>{" "}
            </li>
            <li>
              <button className="tamil">Tamil</button>
            </li>
            <li>
              <button className="telgu">Telugu</button>
            </li>
            <li>
              <ArrowRight size={32} /> see more{" "}
            </li>
          </ul>
        </div>
      </div>
      </main>
    </>
  );
}

export default LanguageListingPage;
